{
    "nav": {
        "console": "شاشة الوكيل",
        "wallboard": "لوحة المتابعة",
        "reporting": "تقارير مركز الاتصال",
        "configuration": "قوائم الانتظار والوكلاء",
        "chatbot": "المحادث الآلي",
        "ivr": "مصمّم الرد الصوتي",
        "licensing": "التراخيص"
    },
    "console": {
        "title": "شاشة الوكيل",
        "signed_out": "أنت خارج النظام",
        "signed_out_help": "سجّل الدخول لبدء استقبال المحادثات.",
        "sign_in": "تسجيل الدخول",
        "sign_out": "تسجيل الخروج",
        "state": "حالتي",
        "reason": "السبب",
        "next": "استلام التالي",
        "nothing_waiting": "لا يوجد ما يمكنك استلامه.",
        "waiting": "في الانتظار",
        "no_contact": "لا توجد محادثة مفتوحة",
        "no_contact_help": "استلم المحادثة التالية أو انتظر أن تُحوَّل إليك واحدة.",
        "answer": "الرد",
        "hold": "تعليق",
        "resume": "إلغاء التعليق",
        "end": "إنهاء",
        "close": "الإغلاق وتسجيل النتيجة",
        "transfer": "تحويل",
        "internal_note": "ملاحظة داخلية",
        "send": "إرسال",
        "message_placeholder": "اكتب رداً…",
        "internal_hint": "الملاحظات الداخلية يراها الزملاء فقط.",
        "wrap_up": "سجّل النتيجة",
        "disposition": "النتيجة",
        "notes": "الملاحظات",
        "resolved_first_contact": "حُلّت في هذه المحادثة",
        "transfer_to_agent": "إلى زميل",
        "transfer_to_queue": "إلى قائمة انتظار",
        "announced": "تقديم العميل أولاً",
        "note": "ملاحظة للوكيل المستلم",
        "load": "{{count}} مفتوحة",
        "capacity_voice": "المكالمات الصوتية واحدة في كل مرة",
        "skills": "المهارات",
        "waiting_seconds": "منتظر منذ {{time}}",
        "talk_time": "قيد التحدث {{time}}",
        "on_hold": "معلّقة منذ {{time}}",
        "customer": "العميل",
        "open_complaints": "{{count}} شكاوى مفتوحة",
        "open_record": "فتح سجل العميل",
        "unidentified": "لم يُعرَّف بعد",
        "vip": "عميل مميز",
        "bot_handled": "بدأت مع المحادث الآلي",
        "transferred_in": "محوَّلة إليك"
    },
    "wallboard": {
        "title": "مركز الاتصال",
        "subtitle": "مباشر",
        "waiting": "في الانتظار",
        "longest_wait": "أطول انتظار",
        "active": "جارية",
        "held": "معلّقة",
        "signed_in": "مسجّلون",
        "available": "متاحون",
        "busy": "مشغولون",
        "on_break": "بعيدون",
        "queues": "قوائم الانتظار",
        "agents": "الوكلاء",
        "queue": "قائمة الانتظار",
        "target": "المستهدف",
        "state": "الحالة",
        "for_time": "منذ {{time}}",
        "callbacks": "معاودة الاتصال",
        "callbacks_pending": "قيد الانتظار",
        "callbacks_overdue": "متأخرة",
        "callbacks_failed": "فشلت اليوم",
        "today": "اليوم",
        "arrived": "الواردة",
        "answered": "المجابة",
        "abandoned": "المتروكة",
        "asa": "متوسط زمن الرد",
        "aht": "متوسط زمن المعالجة",
        "service_level": "مستوى الخدمة",
        "fcr": "الحل من أول اتصال",
        "no_data": "لا توجد محادثات في هذه الفترة.",
        "supervise": "الاستماع",
        "monitor": "استماع",
        "whisper": "همس للوكيل",
        "barge": "الانضمام للمكالمة",
        "assign": "إسناد إلى…",
        "alerts": {
            "ok": "ضمن المستهدف",
            "warning": "تجاوز المستهدف",
            "critical": "تجاوز كبير للمستهدف"
        }
    },
    "reporting": {
        "title": "تقارير مركز الاتصال",
        "from": "من",
        "to": "إلى",
        "queue": "قائمة الانتظار",
        "all_queues": "كل القوائم",
        "run": "تشغيل",
        "by_channel": "حسب القناة",
        "by_agent": "حسب الوكيل",
        "agent": "الوكيل",
        "handled": "المعالَجة",
        "aht": "متوسط المعالجة",
        "transfers": "التحويلات",
        "occupancy": "نسبة الانشغال",
        "signed_in": "مدة التسجيل",
        "export": "تصدير CSV"
    },
    "configuration": {
        "title": "قوائم الانتظار والوكلاء",
        "queues": "قوائم الانتظار",
        "skills": "المهارات",
        "agents": "الوكلاء",
        "dispositions": "النتائج",
        "code": "الرمز",
        "name": "الاسم",
        "name_en": "الاسم (بالإنجليزية)",
        "name_ar": "الاسم (بالعربية)",
        "skill": "المهارة",
        "channels": "القنوات",
        "target": "المستهدف للرد (ثانية)",
        "priority": "الأولوية",
        "overflow": "التحويل الفائض إلى",
        "overflow_after": "التحويل الفائض بعد (ثانية)",
        "after_hours": "خارج أوقات العمل",
        "callback_after": "عرض معاودة الاتصال بعد (ثانية)",
        "active": "مفعّلة",
        "save": "حفظ",
        "new_queue": "إضافة قائمة",
        "edit": "تعديل",
        "extension": "التحويلة",
        "max_chats": "المحادثات المتزامنة",
        "accepts_voice": "يستقبل مكالمات",
        "accepts_chat": "يستقبل محادثات",
        "proficiency": "مستوى الإتقان",
        "has_seat": "مرخّص",
        "no_seat": "بلا ترخيص",
        "telephony": "منصة الاتصالات",
        "telephony_simulated": "يعمل على المحاكي المدمج — لا تخرج أي مكالمة من هذا النظام.",
        "telephony_offshore": "مستضاف خارج السلطنة: سيخرج صوت المكالمات من البلد.",
        "after_hours_options": {
            "callback": "عرض معاودة الاتصال",
            "voicemail": "استقبال رسالة صوتية",
            "closed": "إبلاغ العميل بالإغلاق",
            "overflow": "التحويل إلى القائمة الفائضة"
        }
    },
    "chatbot": {
        "title": "المحادث الآلي",
        "intents": "النوايا",
        "code": "الرمز",
        "name": "الاسم",
        "patterns_en": "عبارات التشغيل (بالإنجليزية)",
        "patterns_ar": "عبارات التشغيل (بالعربية)",
        "response_en": "الرد (بالإنجليزية)",
        "response_ar": "الرد (بالعربية)",
        "escalates": "التحويل إلى موظف",
        "escalate_to": "التحويل إلى",
        "quick_replies": "ردود مقترحة",
        "matched": "مرات المطابقة",
        "escalated": "مرات التحويل",
        "escalation_rate": "نسبة التحويل",
        "active": "مفعّلة",
        "save": "حفظ النية",
        "new": "إضافة نية",
        "test": "جرّبها",
        "test_message": "اكتب رسالة عميل",
        "test_result": "طابقت {{intent}} بثقة {{confidence}}",
        "test_none": "لم تطابق أي نية — كانت ستُحوَّل إلى موظف.",
        "add_pattern": "إضافة عبارة",
        "patterns_hint": "يُبحث في اللغتين مهما كانت لغة العميل.",
        "add_phrase": "أضف عبارة"
    },
    "ivr": {
        "title": "مصمّم الرد الصوتي",
        "flow": "المسار",
        "inbound_number": "الرقم الوارد",
        "node": "الخطوة",
        "type": "النوع",
        "digit": "يُبلغ بالضغط على",
        "prompt_en": "النص (بالإنجليزية)",
        "prompt_ar": "النص (بالعربية)",
        "queue": "قائمة الانتظار",
        "add_child": "إضافة خطوة تحتها",
        "remove": "حذف",
        "save": "حفظ المسار",
        "reached": "وصل إليها {{count}} متصلاً",
        "entry": "نقطة البداية",
        "types": {
            "menu": "قائمة",
            "message": "رسالة",
            "queue": "تحويل إلى قائمة انتظار",
            "callback": "عرض معاودة الاتصال",
            "voicemail": "رسالة صوتية",
            "hangup": "إنهاء المكالمة",
            "language": "اختيار اللغة"
        },
        "preview": "معاينة",
        "preview_hint": "تسلك المسار نفسه الذي تسلكه مكالمة حقيقية.",
        "press": "اضغط {{digit}}",
        "restart": "البدء من جديد"
    },
    "licensing": {
        "title": "التراخيص",
        "licensed": "المقاعد المرخّصة",
        "granted": "الممنوحة",
        "signed_in": "المسجّلون الآن",
        "peak": "الذروة المتزامنة",
        "peak_at": "بلغت في {{when}}",
        "mean": "المتوسط المتزامن",
        "headroom": "الهامش المتاح",
        "seats": "المقاعد",
        "agent": "الوكيل",
        "type": "النوع",
        "granted_at": "تاريخ المنح",
        "expires": "تاريخ الانتهاء",
        "reason": "السبب",
        "grant": "منح مقعد",
        "revoke": "سحب",
        "permanent": "دائم",
        "temporary": "مؤقت",
        "never": "لا ينتهي",
        "usage": "الاستخدام",
        "recommendations": {
            "unconfigured": "لم يُضبط حد للمقاعد.",
            "at_capacity": "استُهلك الترخيص بالكامل — سيُرفض تسجيل الدخول التالي.",
            "approaching_capacity": "الاستخدام قريب من الحد المرخّص.",
            "over_licensed": "الاستخدام أقل بكثير من الحد المرخّص.",
            "healthy": "الاستخدام ضمن الترخيص بأريحية."
        }
    },
    "widget": {
        "title": "تحدّث إلينا",
        "open": "تحدّث إلينا",
        "closed_now": "المحادثة مغلقة حالياً.",
        "placeholder": "اكتب رسالتك…",
        "send": "إرسال",
        "start": "بدء محادثة",
        "waiting_for_agent": "في انتظار أحد الزملاء — ترتيبك {{position}} في قائمة الانتظار.",
        "with_agent": "أنت تتحدث مع {{name}}",
        "bot": "المساعد",
        "you": "أنت",
        "request_callback": "اطلب أن نتصل بك",
        "phone": "رقم الهاتف",
        "name": "الاسم (اختياري)",
        "callback_sent": "شكراً لك — سنعاود الاتصال بك.",
        "estimated_wait": "حوالي {{count}} دقيقة",
        "new_conversation": "بدء محادثة جديدة"
    },
    "status": {
        "queued": "في الانتظار",
        "ringing": "جارٍ الرنين",
        "active": "جارية",
        "held": "معلّقة",
        "wrap_up": "إنهاء الإجراءات",
        "closed": "مغلقة",
        "abandoned": "متروكة"
    },
    "agent_status": {
        "available": "متاح",
        "busy": "مشغول باتصال",
        "wrap_up": "إنهاء الإجراءات",
        "break": "في استراحة",
        "training": "في تدريب",
        "meeting": "في اجتماع",
        "offline": "خارج النظام"
    },
    "channel": {
        "phone": "هاتف",
        "chat": "محادثة الموقع",
        "whatsapp": "واتساب",
        "email": "بريد إلكتروني",
        "sms": "رسالة نصية",
        "social_media": "وسائل التواصل"
    }
}
